/**
 * Turn an object into an error. This is necessary because babel v6 and older doesn't support extending builtins
 * like Error. Effectively this should be like calling super(message) if it were possible to extend Error.
 */
function makeIntoError(error, message) {
  /* eslint-disable no-param-reassign */
  error.name = error.constructor.name;
  error.message = message;
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(error, error.constructor);
  } else {
    error.stack = (new Error(message)).stack;
  }
  /* eslint-enable no-param-reassign */
}

export default function InvalidFormError(message) {
  makeIntoError(this, message);
}
InvalidFormError.prototype = Object.create(Error.prototype);
